import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/index';
import Products from './pages/products';
import Login from './auth/login';
import ForgetPassword from './auth/forget-password';
import ResetPassword from './auth/reset-password';
import AdminDashboard from './pages/admin/dashboard';
import ProductDetailed from './pages/product-detailed';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import GuestRoute from './components/GuestRoute';
import Promotions from './pages/promotions';
import Contact from './pages/contact';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Routes>
          {/* main urls */}
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/product/:id/:name/:desc/:coverImg" element={<ProductDetailed />} />
          {/* auth urls */}
          <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
          <Route path="/forget-password" element={<GuestRoute><ForgetPassword /></GuestRoute>} />
          <Route path="/reset-password" element={<GuestRoute><ResetPassword /></GuestRoute>} />
          {/* admin urls */}
          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
